var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{class:['header-sticky', { 'sticky-top': _vm.generalSettings.sticky_header == 1 }]},[_c('LogoBar',{attrs:{"loading":_vm.loading,"data":_vm.data}}),_c('HeaderMenu',{staticClass:"d-none d-md-block",attrs:{"loading":_vm.loading,"data":_vm.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }